module.exports = __webpack_public_path__ + "assets/9111c4bb3527fc670513042733b18d27.mp3";